import { LIMITS } from '../constants/ui';

export interface Platform {
  name: string;
  intentUrl: string;
  hashtag: string;
  icon: string;
  maxChars?: number;
}

export interface Platforms {
  twitter: Platform;
  bluesky: Platform;
  farcaster: Platform;
}

export const platforms: Record<string, Platform> = {
  twitter: {
    name: 'X/Twitter',
    intentUrl: 'https://twitter.com/intent/tweet?text=',
    hashtag: '#t',
    icon: '/img/ico-x.svg',
    maxChars: 280
  },
  bluesky: {
    name: 'Bluesky',
    intentUrl: 'https://bsky.app/intent/compose?text=',
    hashtag: '#b',
    icon: '/img/ico-bluesky.svg',
    maxChars: 300
  },
  farcaster: {
    name: 'Farcaster',
    intentUrl: 'https://warpcast.com/~/compose?text=',
    hashtag: '#f',
    icon: '/img/ico-farcaster.svg',
    maxChars: LIMITS.FARCASTER_MAX_CHARS
  }
}; 